import {
  ChalkboardTeacherIcon,
  CityIcon,
  SchoolIcon,
  UserClassIcon,
  UserIcon
} from "../../../icons"
import {
  getSearchedClasses,
  getSearchedDistricts,
  getSearchedSchools,
  getSearchedStudents,
  getSearchedTeachers
} from "../../../redux/actions/appFilters"

const LabelToIconsMapping: {
  [key: string]: React.ComponentType<React.PropsWithChildren<any>>
} = {
  district: CityIcon,
  school: SchoolIcon,
  teacher: ChalkboardTeacherIcon,
  class: UserClassIcon,
  s: UserIcon
}

const LabelToStateMapping: { [key: string]: string } = {
  district: "districts",
  school: "schools",
  teacher: "teachers",
  class: "classes",
  s: "students"
}

const StateToLabelMapping: { [key: string]: string } = {
  districts: "district",
  schools: "school",
  teachers: "teacher",
  classes: "class",
  students: "s"
}

// TODO: Define type
const LabelToActionCreatorMapping: { [key: string]: any } = {
  district: getSearchedDistricts,
  school: getSearchedSchools,
  teacher: getSearchedTeachers,
  class: getSearchedClasses,
  s: getSearchedStudents
}

const LabelToLoadingMapping: { [key: string]: string } = {
  district: "isFetchingDistricts",
  school: "isFetchingSchools",
  teacher: "isFetchingTeachers",
  class: "isFetchingClasses",
  s: "isFetchingStudents"
}

const LabelToPaginatingMapping: { [key: string]: string } = {
  district: "isPaginatingDistricts",
  school: "isPaginatingSchools",
  teacher: "isPaginatingTeachers",
  class: "isPaginatingClasses",
  s: "isPaginatingStudents"
}

const LabelToCursorMapping: { [key: string]: string } = {
  district: "districtsCursor",
  school: "schoolsCursor",
  teacher: "teachersCursor",
  class: "classesCursor",
  s: "studentsCursor"
}

type Option = {
  label: string
  value: string
}

type Selected = {
  district?: Option
  school?: Option
  teacher?: Option
  class?: Option
  s?: Option
}

type AppFilterType = {
  label: string
  l_label: string
  studentSearchKey: string
  collection: string
  placeholder: string
}

export {
  LabelToIconsMapping,
  LabelToStateMapping,
  LabelToActionCreatorMapping,
  LabelToLoadingMapping,
  LabelToPaginatingMapping,
  LabelToCursorMapping,
  StateToLabelMapping
}

export type { Option, Selected, AppFilterType }
